module.exports = __webpack_public_path__ + "open-sans-latin-300italic.cc71ca88a161a2b23363.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-300italic.woff2
// module id = ../../../../typeface-open-sans/files/open-sans-latin-300italic.woff2
// module chunks = 1 3